import React from 'react'
import { BlocResultat, Conditionnal, Header } from '../ImportAll'

export default function Vue20() {
    return (
        <div>
            <Conditionnal
                linked_data_id="tech_env_offre_status"
                isEqualTo
                targetDataValueCompare="LOAD"
            >
                <Header
                    title="Vous possédez deja un crédit ou une offre de banque ?"
                    subTitle="Envoi en cours des données..."
                />
                <div className="Container">
                    <BlocResultat key="key163" comparer load />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="tech_env_offre_status"
                isEqualTo
                targetDataValueCompare="SEND"
            >
                <Header
                    title="Vous possédez deja un crédit ou une offre de banque ?"
                    subTitle="Données envoyées avec succès"
                />
                <div className="Container">
                    <BlocResultat key="key163" comparer send />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="tech_env_offre_status"
                isEqualTo
                targetDataValueCompare="ERR"
            >
                <Header
                    title="Vous possédez deja un crédit ou une offre de banque ?"
                    subTitle="Données non envoyées"
                />
                <div className="Container">
                    <BlocResultat key="key163" comparer err />
                </div>
            </Conditionnal>
        </div>
    )
}
